import { UserSaleOffer } from '../models'
import { getTransformedDate } from '../helpers'
import type { ColumnsType } from 'antd/lib/table'
import {
  CustomText,
  CustomHeaderText,
  SaleOfferPriceColumn,
  SaleOfferTotalColumn,
  SaleOfferStatusColumn,
  SaleOfferActionsColumn,
  SaleOfferProjectColumn,
  SaleOfferMovileViewColumn,
} from 'src/components'

const ctOffersColumns: ColumnsType<UserSaleOffer> = [
  /* User Sale Offer Data */

  {
    title: () => <CustomHeaderText text='Offers.Project' />,
    responsive: ['sm'],
    sorter: (a: UserSaleOffer, b: UserSaleOffer) => a.project_name.length - b.project_name.length,
    render: (_, offer) => <SaleOfferProjectColumn offer={offer} />
  },
  {
    title: () => <CustomHeaderText text='Deposits.Amount' />,
    responsive: ['sm'],
    sorter: (a: UserSaleOffer, b: UserSaleOffer) => a.price_per_unit - b.price_per_unit,
    render: (_, offer) => <SaleOfferPriceColumn offer={offer} />
  },
  {
    title: () => <CustomHeaderText text='SalesOffer.Total' isCentered />,
    responsive: ['sm'],
    align: 'center',
    render: (_, offer) => <SaleOfferTotalColumn offer={offer} />
  },
  {
    title: () => <CustomHeaderText text='SalesOffer.ExpirationDate' isCentered />,
    responsive: ['sm'],
    align: 'center',
    sorter: (a: UserSaleOffer, b: UserSaleOffer) => {
      const dateA = new Date(a.expiration_date)
      const dateB = new Date(b.expiration_date)
      return dateA.getTime() - dateB.getTime()
    },
    render: (_, offer) => {
      const label = offer.expiration_date ? getTransformedDate(offer.expiration_date) : '-'
      return <CustomText label={label} />
    }
  },
  {
    title: () => <CustomHeaderText text='Deposits.Status' isCentered />,
    responsive: ['sm'],
    align: 'center',
    render: (_, offer) => <SaleOfferStatusColumn offer={offer} />
  },
  /* Actions */
  {
    title: () => <CustomHeaderText text='Deposits.Actions' isCentered />,
    responsive: ['sm'],
    render: (_, offer) => <SaleOfferActionsColumn offer={offer} />
  },
  /* Mobile View */
  {
    title: () => <CustomHeaderText text='SalesOffer.SaleOffer' isCentered />,
    responsive: ['xs'],
    sorter: (a: UserSaleOffer, b: UserSaleOffer) => a.project_name.length - b.project_name.length,
    render: (_, offer) => <SaleOfferMovileViewColumn offer={offer} />
  },
]

export default ctOffersColumns
